import { load } from '@cashfreepayments/cashfree-js';

let cashfreePromise = null;

export const getCashfreeMode = () =>
  process.env.REACT_APP_CF_ENV === 'production' ? 'production' : 'sandbox';

export const loadCashfree = () => {
  if (!cashfreePromise) {
    cashfreePromise = load({ mode: getCashfreeMode() });
  }
  return cashfreePromise;
};

export const openCashfreeCheckout = async ({
  paymentSessionId,
  redirectTarget = '_modal',
  returnUrl,
}) => {
  const cashfree = await loadCashfree();
  return cashfree.checkout({
    paymentSessionId,
    redirectTarget,
    ...(returnUrl ? { returnUrl } : {}),
  });
};

/**
 * Open Cashfree UPI AutoPay mandate page.
 * Redirects the user to the payment_link returned by the subscription API.
 */
export const openCashfreeSubscription = ({ paymentLink, returnUrl }) => {
  if (!paymentLink) throw new Error('No payment link available for UPI AutoPay mandate');
  // Append return_url as query param so Cashfree redirects back after mandate
  const url = returnUrl
    ? `${paymentLink}${paymentLink.includes('?') ? '&' : '?'}return_url=${encodeURIComponent(returnUrl)}`
    : paymentLink;
  window.location.href = url;
};

export const shouldVerifyCashfreePayment = (result) =>
  Boolean(result?.paymentDetails || result?.redirect);
